export function getSize(scrollbar) {
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl;

    // var scrollContentHeight = 0;
    //
    // if(scrollContentHeight == 0){
    //     scrollContentHeight = 8250;
    // }

    return {
        container: {
            // requires `overflow: hidden`
            width: containerEl.clientWidth,
            height: containerEl.clientHeight,
        },
        content: {
            // border width should be included
            width: contentEl.offsetWidth - contentEl.clientWidth + contentEl.scrollWidth,
            height: contentEl.offsetHeight - contentEl.clientHeight + contentEl.scrollHeight,
            //lifehack, prevent
            //height: contentEl.offsetHeight - contentEl.clientHeight + scrollContentHeight,
        },
    };
}
//# sourceMappingURL=get-size.js.map